import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('recipe-recommendations', {
  onLoad() {
    const recipeRecommendationsSlider = document.querySelector('.recipe-recommendations__slider');
    if (recipeRecommendationsSlider) {
      new Flickity(recipeRecommendationsSlider, {
        // options
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });
    }
  },
});
